// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1w5Ua","left":"styles_left__1_o-F","desktopActions":"styles_desktopActions__2Z5Eg","title":"styles_title__2f_qX"};